import styled from 'styled-components';
import colors from '@constants/Colors';

export const Wrapper = styled.a`
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 300;
  color: inherit;
  text-decoration: none;
  border-top: 1px solid ${colors.lightGreyish};
  border-bottom: 1px solid ${colors.lightGreyish};
  cursor: pointer;

  :hover {
    color: ${colors.periwinkleStrong};
  }

  p {
    margin: 0;
  }
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
`;
